<template>
  <a-form-item
    v-if="data && options"
    :label="data.fieldname"
    class="cascader"
  >
    <slot />
    <a-cascader
      :value="defaultValue"
      :show-search="true"
      :options="options"
      :placeholder="placeholder"
      change-on-select
      :not-found-content="$t('message[1972]')"
      @change="onChange"
      @popupVisibleChange="popupVisibleChange"
    />
    <slot name="relate-list" />
  </a-form-item>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => { }
    },
    getData: {
      type: Function,
      default: () => { }
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultValue: [],
      options: null
    }
  },
  computed: {
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      let string = placeholder || this.$t('message["855"]') + spaceStr + fieldname

      return string
    }
  },
  watch: {
    data: {
      handler (val) {
        this.defaultValue = []
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  async created () {
    this.init()
    this.setDefaultOptionsList()
  },
  methods: {
    async loadData () {
      const { fieldkey = '', fieldtype = '' } = this.data || {}
      const data = await this.getData({ fieldkey, fieldtype })

      return data
    },
    setOptions (options) {
      for (let item of options) {
        item.label = item.name || item.fieldname
        let value = item.id === undefined ? item.fieldkey : item.id
        item.value = value + '-' + item.keyname
        item.key = item.pId + '-' + item.value

        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let child of item.children) {
            child.pId = item.pId + '-' + (item.id || item.fieldkey)
          }
          this.setOptions(item.children)
        }
      }
      this.options = options
      this.$forceUpdate()
    },
    init () {
      if (this.value && this.value.length) {
        this.defaultValue = this.value
      } else {
        this.defaultValue = this.setDefaultValue(this.data)
      }
    },
    async setDefaultOptionsList () {
      let loadOptions = await this.loadData()

      const { options, child } = this.data

      this.options = loadOptions || options || child || []

      if (this.options && this.options.length) {
        for (let item of this.options) {
          item.pId = '0'
        }
        this.setOptions(this.options)
      }
    },
    /**
     * 处理默认value值
     */
    setDefaultValue (item = {}) {
      let arr = []
      const { info = {} } = item
      const { roleid = 0, groupid = 0, userid = 0 } = info

      arr = []
      if (roleid) {
        arr.push(`${roleid}-roleid`)
      }
      if (groupid) {
        arr.push(`${groupid}-groupid`)
      }
      if (userid) {
        arr.push(`${userid}-userid`)
      }
      return arr
    },
    onChange (value, selectedOptions) {
      // console.log(selectedOptions)
      this.defaultValue = value
      this.data.fieldvalue = value

      if (this.data.fieldkey === 'from_info' || this.data.fieldtype === 'select_reception') {
        this.data.value = []
        if (selectedOptions && selectedOptions.length) {
          selectedOptions.forEach(item => {
            // this.data.value.push(item.fieldkey)
            this.data.value.push(item.id)
          })
        }
      } else {
        this.data.info = this.data.info || {}
        this.data.info.roleid = 0
        this.data.info.groupid = 0
        this.data.info.userid = 0
        if (selectedOptions && selectedOptions.length) {
          selectedOptions.forEach(item => {
            let { value = '' } = item
            this.data.info[item.keyname] = value && value.split('-') && value.split('-')[0]
          })
        }
      }

      this.$emit('change', this.data)
    },
    popupVisibleChange (val) {
      if (val) {
        this.setDefaultOptionsList()
      }
    },
    clearCascader () {
      this.defaultValue = []
    },
    updateFollowOptions (options) {
      this.setOptions(options)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
